
import { CREATE_POLL , CAST_VOTE, DETAIL_POLL} from './constants';
import { getPublicIP, getAuthHeader , setJWTToken, setUserInSession } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse , loader } from './utils';

export const newPoll = (newPoll) => {
 
  return {
    type: CREATE_POLL,
    newPoll,
  };
};

export const createPolling = (params) => {

  const bodyFormData = new FormData();
  Object.keys(params).map(function(key, index) {
    bodyFormData.set(key, params[key]);
  });
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/polling/create_polling`, bodyFormData , headers)
  .then(handleResponse)
  .then((res) => {
    dispatch(newPoll(res))
  });
};



export const castVote = (castVote) => {
 
  return {
    type: CAST_VOTE,
    castVote,
  };
};


export const castPollingVote = (params) => {

  const bodyFormData = new FormData();
  Object.keys(params).map(function(key, index) {
    bodyFormData.set(key, params[key]);
  });
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/polling/caste_vote`, bodyFormData , headers)
  .then(handleResponse)
  .then((res) => {
    dispatch(castVote(res))
  });
};

export const detailPoll = (detailPoll) => {
 
  return {
    type: DETAIL_POLL,
    detailPoll,
  };
};


export const detailPolling = (params) => {

  const bodyFormData = new FormData();
  Object.keys(params).map(function(key, index) {
    bodyFormData.set(key, params[key]);
  });
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/userfeed/post_details`, bodyFormData , headers)
  .then(handleResponse)
  .then((res) => {
    dispatch(detailPoll(res))
  });
};

